import { useCurrentUser } from './use-current-user';

export const useIsLogin = () => {
  const { uuid } = useCurrentUser();
  return !!uuid;
};
